import {slideDown} from './slideUpDown';
import {slideUp} from './slideUpDown';

export const accordion = () => {
    const accordionList = document.querySelectorAll('.c-accordion');

    accordionList.forEach((el) => {
        const trigger = el.querySelector('.js-accordion-trigger');
        const content = el.querySelector('.c-accordion__content');

        content.style.display = 'none';

        if (el.classList.contains('c-accordion--active')) {
            content.style.display = 'block';
        }

        if (trigger != null) {
            trigger.addEventListener('click', () => {
                const currentContainer = trigger.closest('.c-accordion');
                currentContainer.classList.toggle('c-accordion--active');

                if (currentContainer.classList.contains('c-accordion--active')) {
                    slideDown(currentContainer.querySelector('.c-accordion__content'));
                } else {
                    slideUp(currentContainer.querySelector('.c-accordion__content'));
                }
            });
        }
    });
};
